import { useState,useEffect, useMemo } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogTitleDefault from '../default/DialogTitleDefault';
import { Box, Divider, Grid, TextField, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { ButtonBasic, SelectMotivoBajaTk, SelectSubMotivoBaja, SelectSubTipoTicket } from '../../components';
import NivelAdmTkService from '../../services/nivelAdmTicket.service';
import MotivoBajaTkService from '../../services/motivoBajaTk.service';

const ModalMotivoBaja = ({show, hideModal, item, onGuardar, type}) => {
    console.log(item)
    const theme = useTheme();
    const isDarkMode = theme.palette.mode === 'dark';
    const [isLoading, setIsLoading] = useState(false);
    const handleClose = () => hideModal();
    const [subMotivoArr, setSubMotivoArr] = useState(item?.arrSubMotivoBaja || []);
    const [formAll, setFormAll] = useState({
        nombre_mbtk: {
            texto: null,
            textoErr: 'El titulo es requerido',
            estadoErr: false,
            tipo: 'string'
        },
        nivelAdmId_mbtk: {
            texto: null,
            textoErr: 'El titulo es requerido',
            estadoErr: false,
            tipo: 'string'
        }
    });
    const onChangeForm = (value,input) =>{
        let formOld = formAll;
        if(!formOld[input]){
            formOld[input] = {
                texto: value,
                textoErr: `El ${input} es requerido`,
                estadoErr: false,
                tipo: 'string'
            }
        }else{
            formOld[input].texto = value
        }
        if(!value || value === ''){
            formOld[input].estadoErr = true
        }else{
            formOld[input].estadoErr = false;
        }
        setFormAll({...formOld})
    }
    const onChangeFormSetError = (input,clear) =>{
        let formOld = formAll;
        formOld[input].estadoErr = !clear ? true : false
        setFormAll({...formOld})
    }
    const onSubmit = async() => {
        const form = {subMotivoArr};
        let isOk = false;
        setIsLoading(true);
        const inputRequired = ['nombre_mbtk','nivelAdmId_mbtk']
        const propertyNames = Object.keys(formAll);
        await Promise.resolve(
        propertyNames.forEach((name)=>{
        if(formAll[name]?.texto && formAll[name]?.texto !== '' && !formAll[name]?.estadoErr){
            form[name] = formAll[name].texto
        }else{
            if(inputRequired.includes(name)){
                isOk = true;
                onChangeFormSetError(name)
            }
        }
        }))
        if(!isOk){
            if(item?.id_mbtk > 0) {
                form.id_mbtk = item.id_mbtk
                await MotivoBajaTkService.update(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }else{
                await MotivoBajaTkService.register(form)
                    .then(() => {
                        onGuardar();
                        hideModal();
                    })
                    .finally(() => {
                        setIsLoading(true);
                    });
            }
        }else{
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if(item){
            setTimeout(() => {
                onChangeForm(item?.nombre_mbtk,'nombre_mbtk')
                onChangeForm(item?.nivelAdmId_mbtk,'nivelAdmId_mbtk')
            }, 100);
        }
    }, [item])

    const styleInput = useMemo(() => ({
        '& .MuiInputLabel-root':{
            color: isDarkMode ? '#b0bec5' : 'gray',
            fontSize: 14,
            marginTop: -0.4
        },
        '& fieldset': {
            borderRadius: 2,
            height: 50,
            border: 1,
            borderColor: isDarkMode ? '#3d4a62' : 'gray',
        },
        '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
                border:1,
                color: isDarkMode ? '#e0e0e0' : '#000',
                borderColor: isDarkMode ? '#90caf9' : '#0364ff',
                height: 50,
            },
            '&:hover':{
                border: 0.1,
                borderRadius: 2,
                borderColor: isDarkMode ? '#3d4a62' : 'gray',
                height: 45,
            },
            '&.Mui-focused': {
                '&:hover':{
                    border: 0,
                    borderRadius: 2,
                    height: 45,
                }
            },
            color: isDarkMode ? '#e0e0e0' : 'gray',
            height: 45,
        }
    }), [isDarkMode]);

    return(
        <Dialog open={show} disableEscapeKeyDown maxWidth='sm' fullWidth sx={{backdropFilter: 'blur(0.4px);'}}>
            <Box sx={{background: isDarkMode ? '#2d3a52' : '#fff'}}>
                <DialogTitleDefault id="add-canal-priv" onClose={handleClose}>
                    <Typography sx={{flex:1,textAlign: 'center', color: isDarkMode ? '#e0e0e0' : '#000',fontWeight: 'bold'}} variant='h5'>
                        {item?.id_mbtk > 0 ? 'Editar Motivo de Baja' : 'Registrar Motivo de Baja'}
                    </Typography>
                </DialogTitleDefault>
                <Divider sx={{borderColor: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogContent>
                    <Grid container spacing={1}>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Nombre</Typography>
                            <TextField
                                fullWidth
                                autoComplete='off'
                                value={formAll.nombre_mbtk.texto}
                                error={formAll.nombre_mbtk.estadoErr}
                                helperText={formAll.nombre_mbtk.estadoErr && formAll.nombre_mbtk.textoErr}
                                onChange={(e)=>onChangeForm(e.target.value, 'nombre_mbtk')}
                                sx={styleInput}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Sub-Tipo</Typography>
                            <SelectSubTipoTicket
                                value={formAll.nivelAdmId_mbtk.texto}
                                onChange={(e)=>onChangeForm(e.value,'nivelAdmId_mbtk')}
                                isInvalid={formAll.nivelAdmId_mbtk.estadoErr}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography sx={{color: isDarkMode ? '#e0e0e0' : '#000'}}>Sub-Motivo de Baja</Typography>
                            <SelectSubMotivoBaja
                                isMulti
                                value={subMotivoArr}
                                onChange={(opt) => setSubMotivoArr(opt.map(op=>(op.value)))}
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider sx={{borderColor: isDarkMode ? '#3d4a62' : 'gray'}} />
                <DialogActions sx={{display:'flex', justifyContent:'center'}}>
                    <ButtonBasic
                        textButton='Cancelar'
                        variant='wk'
                        color='cancel'
                        onClick={()=>handleClose()}
                        isLoading={isLoading}
                    />
                    <ButtonBasic
                        textButton='Guardar'
                        onClick={()=>onSubmit()}
                        isLoading={isLoading}
                        variant='wk'
                        color='nextStep'
                    />
                </DialogActions>
            </Box>
        </Dialog>
    )
}

export default ModalMotivoBaja